import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import { dateFormatters } from '@/utils/date-util'
import { TextField } from '@/components/inputs/TextField'
import { FormField, FormFieldGroup, FormFieldLabel } from '@/components/Form'
import { AgreementRenderer } from '@/features/account/components/AgreementRenderer'
import {
  SignatureDateLabel,
  SignatureSection,
} from '@/features/account/section-7216/components/SignatureSection'

export interface ViewAcceptedSection7216DialogProps {
  isOpen: boolean
  onClose: () => void
  markup: string
  userSignature: string
  spouseSignature?: string
  dateAccepted: Date
  testId?: string
  confirmButtonTestId?: string
}

export function ViewAcceptedSection7216Dialog({
  isOpen,
  onClose,
  markup,
  userSignature,
  spouseSignature,
  dateAccepted,
  testId,
  confirmButtonTestId,
}: ViewAcceptedSection7216DialogProps) {
  return (
    <ModalDialog
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      aria-label="Data disclosure acceptance"
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>Data disclosure acceptance</ModalDialogTitle>
        <ModalDialogDescription>
          You accepted this data disclosure on{' '}
          {dateFormatters.dateLong.format(dateAccepted)}
        </ModalDialogDescription>
      </ModalDialogHeader>
      <ModalDialogContent>
        <AgreementRenderer markup={markup} withBackground />
        <SignatureSection>
          <FormFieldGroup stackWhenCompact>
            <FormField>
              <FormFieldLabel>Your full name</FormFieldLabel>
              <TextField value={userSignature} disabled readOnly />
            </FormField>
            {spouseSignature && (
              <FormField>
                <FormFieldLabel>Spouse's full name</FormFieldLabel>
                <TextField value={spouseSignature} disabled readOnly />
              </FormField>
            )}
          </FormFieldGroup>
          <SignatureDateLabel>
            Signed on {dateFormatters.dateAmerican.format(dateAccepted)}
          </SignatureDateLabel>
        </SignatureSection>
      </ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button label="OK" onPress={onClose} testId={confirmButtonTestId} />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
